/*
class DimensionInput extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      input: '.dimension--input',
      size: '.dimension--size',
      length: '.dimension--length',
      unit: '.dimension--unit',
    };

    this.elements = AfcTheme.utils.queryDomNodes(this.selectors, this);

    this.onChangeHandler = this.onchange.bind(this);

    this.elements.size.addEventListener('change', this.onChangeHandler);
    this.elements.length.addEventListener('change', this.onChangeHandler);
    this.elements.unit.addEventListener('change', this.onChangeHandler);
  }

  onchange() {
    const size = this.elements.size.value;
    const length = this.elements.length.value;
    const unit = this.elements.unit.value;

    const dimension = `${size}x${length} ${unit}`;

    this.elements.input.value = dimension;
  }
}
customElements.define('dimension-input', DimensionInput);

class GetQuoteProjectDetails extends AccordionDetails {
  constructor() {
    super();
  }

  connectedCallback() {
    this.handleFormAccessibily();
  }

  handleAfterToggle() {
    this.handleFormAccessibily();
  }

  handleFormAccessibily() {
    const inputs = this.querySelectorAll(':is(input, select, textarea)[name]');
    inputs.forEach((input) => {
      input.disabled = !this.open;
    });
  }
}
customElements.define('get-quote-project-details', GetQuoteProjectDetails, { extends: 'details' });
*/

class ModalGetQuotePrice extends ModalComponent {
  constructor() {
    super();
  }

  get isLockingNeeded() {
    return true;
  }
}
customElements.define('modal-get-quote-price', ModalGetQuotePrice);

class FileUpload extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      file: '[type="file"]',
      fileWrap: '.file-upload__file',
      fileUploadedUI: '.file-upload__uploaded-ui',
      input: '.file-upload__input',
    };

    this.fileEl = this.querySelector(this.selectors.file);
    this.fileWrapEl = this.querySelector(this.selectors.fileWrap);
    this.inputEl = this.querySelector(this.selectors.input);
    this.fileUploadedUI = this.querySelector(this.selectors.fileUploadedUI);

    this.baseUrl = 'https://app.afcultures.com';
    // this.baseUrl = 'http://localhost:3000';
    this.endpointUrl = `${this.baseUrl}/api/file-upload`;
  }

  get formEl() {
    return (this._formEl = this._formEl || this.closest('form'));
  }

  get submitButtonEl() {
    return (this._submitButtonEl = this._submitButtonEl || this.formEl.querySelector('[type="submit"]'));
  }

  connectedCallback() {
    this.uploadedFiles = [];

    this.maxFiles = parseInt(this.dataset.maxFiles);
    this.maxFilesizeInMb = parseFloat(this.dataset.maxFilesize);
    this.maxFilesizeInBytes = this.maxFilesizeInMb * 1024 * 1024;
    this.maxFilesizeMessage = this.dataset.maxFilesizeMessage;

    if (this.maxFiles < 2) {
      this.fileEl.removeAttribute('multiple');
    }

    this.onChangeHandler = this.onchange.bind(this);
    this.fileEl.addEventListener('change', this.onChangeHandler);

    this.fileUploadedUI.addEventListener('click', this.onRemove.bind(this));
  }

  onchange() {
    this.clearItemErrorUI();
    const remainingSlots = this.maxFiles - this.uploadedFiles.length;

    if (this.fileEl.files.length > 0 && remainingSlots > 0) {
      const selectedFiles = Array.from(this.fileEl.files);
      const filesToAdd = selectedFiles.slice(0, remainingSlots);

      const uploadPromises = [];

      let index = this.uploadedFiles.length - 1;

      for (const file of filesToAdd) {
        if (file.size > this.maxFilesizeInBytes) {
          this.appendFileItemError(file, this.maxFilesizeMessage);
          continue;
        }

        index += 1;
        uploadPromises.push(this.uploadFile(file, index));
      }

      if (uploadPromises.length > 0) {
        this.submitButtonEl.setAttribute('disabled', 'true');
        Promise.all(uploadPromises)
          .then((results) => {
            const fileUrlsToAdd = [];

            results.forEach((result, index) => {
              this.uploadedFiles.push({
                name: result.file.name,
                size: result.file.size,
                url: result.data.fileUrl,
              });
              fileUrlsToAdd.push(result.data.fileUrl);
            });

            this.appendFileUrls(fileUrlsToAdd);
          })
          .catch((error) => {})
          .finally(() => {
            this.submitButtonEl.removeAttribute('disabled');
          });
      }

      this.fileEl.value = ''; // Clear file selection.
    }
  }

  getCurrentFileUrls() {
    let files = [];

    try {
      const oldFiles = JSON.parse(this.inputEl.value);

      files = oldFiles;
    } catch {}

    return files;
  }

  appendFileUrls(newFileUrls) {
    let allFiles = this.getCurrentFileUrls();
    allFiles = allFiles.concat(newFileUrls);

    this.inputEl.value = JSON.stringify(allFiles); // Save new value.
  }

  removeFileUrl(index) {
    let allFiles = this.getCurrentFileUrls();

    allFiles.splice(index, 1);
    this.uploadedFiles.splice(index, 1);

    this.inputEl.value = JSON.stringify(allFiles); // Save new value.
    this.renderUI();
  }

  renderUI() {
    this.checkFileElVisibility();

    let output = '';

    this.uploadedFiles.forEach((file, index) => {
      output += this.getFileItemHTML(file, index);
    });

    this.fileUploadedUI.innerHTML = output;
  }

  getFileItemHTML(file, index) {
    return `
    <li class="file-upload__item theme-radius-sm" data-index="${index}">
      <div class="flex items-center justify-between">
        <div class="file-upload__item-info">
          <span class="file-upload__item-name">${file.name}</span>
          <span class="file-upload__item-size text-sm">${this.formatFileSize(file.size)}</span>
        </div>
        <button class="file-upload__item-remove btn btn--inherit" aria-label="Remove file ${file.name}">
          <svg
            class="icon icon-trash icon--small icon--thick non-scaling-stroke"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path d="M16.875 4.375H3.125" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8.125 8.125V13.125" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11.875 8.125V13.125" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15.625 4.375V16.25C15.625 16.4158 15.5592 16.5747 15.4419 16.6919C15.3247 16.8092 15.1658 16.875 15 16.875H5C4.83424 16.875 4.67527 16.8092 4.55806 16.6919C4.44085 16.5747 4.375 16.4158 4.375 16.25V4.375" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.125 4.375V3.125C13.125 2.79348 12.9933 2.47554 12.7589 2.24112C12.5245 2.0067 12.2065 1.875 11.875 1.875H8.125C7.79348 1.875 7.47554 2.0067 7.24112 2.24112C7.0067 2.47554 6.875 2.79348 6.875 3.125V4.375" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="file-upload__item-bar flex items-center justify-between gap-3">
         <progress-bar class="progress-bar block flex-grow" data-value="0" data-max="100"></progress-bar>
         <div class="file-upload__item-bar-procesced shrink-0 text-right">0%</div>
      </div>
    </li>`;
  }

  clearItemErrorUI() {
    const items = this.fileUploadedUI.querySelectorAll('.file-upload__item-error');

    items &&
      items.forEach((li) => {
        li.remove();
      });
  }

  getFileItemErrorHTML(file, errorMessage) {
    let message = errorMessage || 'Failed to upload this file';

    return `
    <li class="file-upload__item file-upload__item-error theme-radius-sm">
      <div class="flex items-center justify-between">
        <div class="file-upload__item-info">
          <span class="file-upload__item-name">${file.name}</span>
          <span class="file-upload__item-size text-sm">${this.formatFileSize(file.size)}</span>
        </div>
        <svg
          class="text-error icon icon-warning icon--small icon--thick non-scaling-stroke"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10"/>
          <path d="M10 10.625V6.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10 14.375C10.5178 14.375 10.9375 13.9553 10.9375 13.4375C10.9375 12.9197 10.5178 12.5 10 12.5C9.48223 12.5 9.0625 12.9197 9.0625 13.4375C9.0625 13.9553 9.48223 14.375 10 14.375Z" fill="currentColor"/>
        </svg>
      </div>
      <div class="file-upload__item-bar flex items-center justify-between gap-3 text-error">
         <div class="file-upload__item-error-message">${message}</div>
      </div>
    </li>`;
  }

  appendFileItemError(file, errorMessage) {
    let html = this.getFileItemErrorHTML(file, errorMessage);
    this.fileUploadedUI.insertAdjacentHTML('beforeend', html);
  }

  checkFileElVisibility() {
    if (this.maxFiles > this.uploadedFiles.length) {
      this.fileWrapEl.classList.remove('!hidden');
    } else {
      this.fileWrapEl.classList.add('!hidden');
    }
  }

  onRemove(event) {
    const button = event.target.closest('button');

    if (button) {
      event.preventDefault();
      const li = event.target.closest('li');
      const index = li.dataset.index;

      this.removeFileUrl(index);
    }
  }

  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';

    const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const base = 1024;
    const i = Math.floor(Math.log(bytes) / Math.log(base));
    const size = bytes / Math.pow(base, i);

    return `${size.toFixed(2)} ${units[i]}`;
  }

  uploadFile(file, index) {
    return new Promise((resolve, reject) => {
      let newItemHtml = this.getFileItemHTML(file, index);
      this.fileUploadedUI.insertAdjacentHTML('beforeend', newItemHtml);

      const xhr = new XMLHttpRequest();
      const formData = new FormData();
      formData.append('file', file);

      const li = this.fileUploadedUI.children[index];
      const bar = li.querySelector('progress-bar');
      const barText = li.querySelector('.file-upload__item-bar-procesced');

      xhr.open('POST', this.endpointUrl, true);

      xhr.upload.addEventListener('progress', (e) => {
        if (e.lengthComputable) {
          const percent = Math.round((e.loaded / e.total) * 100);
          bar.style.setProperty('--percent', `${percent}%`);
          barText.textContent = `${percent}%`;
        }
      });

      xhr.onload = function () {
        if (xhr.status === 200) {
          try {
            const response = JSON.parse(xhr.responseText);
            resolve({
              file: file,
              data: response,
            });
          } catch (err) {
            reject(new Error('Invalid JSON response'));
          }
        } else {
          reject(new Error(`Upload failed with status ${xhr.status}`));
        }
      };

      xhr.onerror = function () {
        reject(new Error(`Upload failed with status ${xhr.status}`));
      };

      xhr.send(formData);
    });
  }
}
customElements.define('file-upload', FileUpload);

class GetQuotePriceForm extends HTMLFormElement {
  constructor() {
    super();

    this.selectors = {
      logoDesignSupport: '[name="logo_design_support"]',
      fileWrap: '.form-control--file',
      projectDetails: '#ModalGetQuotePrice-project_details',
      tooltips: '.help-tooltip',
    };

    this.hasLogoOption = 'I have a logo';

    this.addEventListener('submit', this.handleFormSubmit.bind(this));

    this.fileEl = this.querySelector('[name="attachments"]');
    this.fileWrapEl = this.querySelector(this.selectors.fileWrap);

    this.baseUrl = 'https://app.afcultures.com';
    // this.baseUrl = 'http://localhost:3000';
    this.endpointUrl = `${this.baseUrl}/api/quote`;

    this.gcKey = this.getAttribute('data-gc-key');
    this.gcAction = this.getAttribute('data-gc-action');
  }

  get messageEl() {
    return (this._errorElement = this._errorElement || this.querySelector('.form__error-messages'));
  }

  get submitButtonEl() {
    return (this._submitButtonEl = this._submitButtonEl || this.querySelector('[type="submit"]'));
  }

  get modalEl() {
    return (this._modalEl = this._modalEl || this.closest('.drawer'));
  }

  get thankyouModalEl() {
    return (this._thankyouModalEl = this._thankyouModalEl || document.querySelector('#ModalGetQuotePriceThankYou'));
  }

  connectedCallback() {
    this.updateFileUploadVisibility();
    this.logoDesignSupportRadioEls = this.querySelectorAll(this.selectors.logoDesignSupport);
    this.logoDesignSupportRadioEls.forEach((radio) => {
      radio.addEventListener('change', this.updateFileUploadVisibility.bind(this));
    });

    this.tooltips = this.querySelectorAll(this.selectors.tooltips);
    this.tooltips &&
      this.tooltips.forEach((tooltip) => {
        tooltip.addEventListener('mouseenter', this.calcTooltipPosition.bind(this));
      });
  }

  calcTooltipPosition(event) {
    const icon = event.target;
    const tooltip = icon.querySelector('.help-tooltip__box');
    const iconRect = icon.getBoundingClientRect();
    const tooltipWidth = tooltip.offsetWidth;

    let left = tooltipWidth / -2;
    const maxLeft = iconRect.left + tooltipWidth / 2;

    if (maxLeft > window.innerWidth) {
      left = 0;
    }

    tooltip.style.setProperty('--offset-x', `${left}px`);
  }

  updateFileUploadVisibility() {
    const selectedValue = this.querySelector(`${this.selectors.logoDesignSupport}:checked`)?.value;
    if (selectedValue === this.hasLogoOption) {
      this.fileWrapEl.classList.remove('!hidden');
    } else {
      this.fileWrapEl.classList.add('!hidden');
    }
  }

  async handleFormSubmit(event) {
    event.preventDefault();

    this.resetErrorMessages();
    if (!this.isValidToSubmit()) {
      this.showErrorMessages();
      return false;
    }

    try {
      const token = await this.getRecaptchaToken();
      this.injectToken(token);

      if (this.submitButtonEl.hasAttribute('aria-disabled')) return;

      const formData = new FormData(this);
      const config = AfcTheme.utils.fetchConfig();
      config.credentials = 'include';
      formData.append('source', window.location.href);

      const data = Object.fromEntries(formData.entries());
      config.body = JSON.stringify(data);

      this.submitButtonEl.setAttribute('aria-disabled', 'true');
      this.submitButtonEl.classList.add('btn--loading');

      this.handleFormSubmission(config);
    } catch (error) {
      console.error('reCAPTCHA error:', error);
    }
  }

  getRecaptchaToken() {
    return new Promise((resolve, reject) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(this.gcKey, { action: this.gcAction }).then(resolve).catch(reject);
      });
    });
  }

  injectToken(token) {
    let input = this.querySelector('input[name="g-recaptcha-response"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'g-recaptcha-response';
      this.appendChild(input);
    }
    input.value = token;
  }

  showErrorMessages() {
    if (this.errorMessages.length > 0) {
      let messages = '';
      this.errorMessages.forEach((message) => {
        messages += `<li>${message}</li>`;
      });
      this.messageEl.innerHTML = `<ul>${messages}</ul>`;
    }
  }

  resetErrorMessages() {
    this.errorMessages = [];
    this.messageEl.innerHTML = '';
  }

  isValidToSubmit() {
    const formData = new FormData(this);
    let isValid = true;

    const hasLogoOrNeedDesignSupport = formData.get('logo_design_support');
    if (this.hasLogoOption === hasLogoOrNeedDesignSupport) {
      let attachments = formData.get('attachments');
      try {
        attachments = attachments ? JSON.parse(attachments) : [];
        if (!Array.isArray(attachments) && typeof attachments !== 'object') {
          attachments = [];
        }
      } catch {
        attachments = [];
      }

      if (attachments.length < 1) {
        this.errorMessages.push('Please upload a logo');
        return false;
      }
    }

    return isValid;
  }

  handleFormSubmission(config) {
    fetch(`${this.endpointUrl}`, config)
      .then((response) => response.json())
      .then(async (data) => {
        if (data.success) {
          this.showThankYouModal();
        } else {
          if (data.message) {
            this.errorMessages.push(data.message);
          } else {
            this.errorMessages.push('There was a problem submitting your quote. Please contact us for assistance.');
          }

          this.showErrorMessages();
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.submitButtonEl.classList.remove('btn--loading');
        this.submitButtonEl.removeAttribute('aria-disabled');
      });
  }

  showThankYouModal() {
    this.modalEl && this.modalEl.hide();
    this.thankyouModalEl && this.thankyouModalEl.show();
  }
}
customElements.define('get-quote-price-form', GetQuotePriceForm, { extends: 'form' });
